import type { UpgradeMessagingChangedAction } from '@web-platform/shared-universal-types/src/redux/actions/upgradeMessaging';

export type { UpgradeMessagingChangedAction };

export const UPGRADE_MESSAGING_CHANGED = 'UPGRADE_MESSAGING_CHANGED';

export const upgradeMessagingChanged = (shouldInject: boolean): UpgradeMessagingChangedAction => ({
  type: UPGRADE_MESSAGING_CHANGED,
  payload: shouldInject,
});
